module.exports = __webpack_public_path__ + "img/loadinggif.64acc289.gif";